import queryString from 'qs';

interface DefaultFilterObject {
  filter: {
    [key: string]: any;
  };
}

export enum FilterKey {
  Adjustment = 'adjustment',
  Category = 'category',
  Subcategory = 'subcategory',
  Brand = 'brand',
  Segment = 'segment',
  SegmentGroups = 'segmentGroups',
  SegmentParentMap = 'segmentParentMap',
  BusinessUnitParentMap = 'businessUnitParentMap',
  SelectionOrder = 'selectionOrder',
  Quadrants = 'quadrants',
  MatchTypes = 'matchTypes',
  BusinessUnit = 'businessunit',
  RetailPrice = 'retailPrice'
}

/**
 *
 * @param filterValues obj {FilterKey }
 * @returns
 */
export const generateFilterUrlString = (
  filterValues: { [filterType: string]: any[] } // Pass an object with filter types as keys and arrays of values
): { generatedFilterParams: string } => {
  const defaultFilterObj: DefaultFilterObject = {
    filter: {}
  };

  // Iterate over the keys of filterValues
  Object.keys(filterValues).forEach((filterType) => {
    const filterValue = filterValues[filterType];

    switch (filterType) {
      case 'category':
        if (filterValue.length > 0) {
          defaultFilterObj.filter.c = filterValue.map((item) => ({ i: item.id }));
        }
        break;
      case 'subcategory':
        if (filterValue.length > 0) {
          defaultFilterObj.filter.sc = filterValue.map((item) => ({ i: item.id }));
        }
        break;
      case 'brand':
        if (filterValue.length > 0) {
          defaultFilterObj.filter.b = filterValue.map((item) => ({ i: item.id }));
        }
        break;
      case 'segment':
        if (filterValue.length > 0) {
          defaultFilterObj.filter.sg = filterValue.map((item) => ({ i: item.id }));
        }
        break;
      case 'segmentGroups':
        if (filterValue.length > 0) {
          // Expecting filterValue as string[][] of segmentIds grouped by parent
          defaultFilterObj.filter.sgg = filterValue.map((group) => group.map((id) => ({ i: id })));
        }
        break;
      case 'segmentParentMap':
        if (filterValue.length > 0) {
          // Expecting [{ s: segmentId, p: parentBuId }]
          defaultFilterObj.filter.sgp = filterValue.map((item) => ({ s: item.s, p: item.p }));
        }
        break;
      case 'businessUnitParentMap':
        if (filterValue.length > 0) {
          // Expecting [{ b: buId, p: parentBuId }]
          defaultFilterObj.filter.bup = filterValue.map((item) => ({ b: item.b, p: item.p }));
        }
        break;
      case 'selectionOrder':
        if (filterValue.length > 0) {
          // Expecting string[] of IDs in order of selection
          defaultFilterObj.filter.so = filterValue;
        }
        break;
      case 'quadrants':
        if (filterValue.length > 0) {
          defaultFilterObj.filter.quadrants = filterValue.map((item) => item);
        }
        break;
      case 'matchTypes':
        if (filterValue.length > 0) {
          defaultFilterObj.filter.matchTypes = filterValue.map((item) => item);
        }
        break;
      case 'businessunit':
        if (filterValue.length > 0) {
          defaultFilterObj.filter.bu = filterValue.map((item) => ({ i: item }));
        }
        break;

      case 'retailPrice':
        if (filterValue.length > 0) {
          defaultFilterObj.filter.rp = filterValue;
        }
        break;
      // Add more cases for other filter types as needed
      default:
        break;
    }
  });

  let stringifiedFilterParams = null;

  // JSON.stringify the default filter object
  if (Object.keys(defaultFilterObj.filter).length > 0) {
    stringifiedFilterParams = `&${queryString.stringify({ filter: JSON.stringify(defaultFilterObj.filter) })}`;
  }

  // Return the generated filter parameters
  return { generatedFilterParams: stringifiedFilterParams };
};

/**
 *  check if min or max is applicable.
 * @param retailPrice filter value
 */
export function validMinMaxRetailPrice(retailPriceArr: { min?: string; max?: string }[]) {
  const isRetailPriceValid = retailPriceArr.some(
    (item) => (item.min !== undefined && item.min !== '') || (item.max !== undefined && item.max !== '')
  );

  return isRetailPriceValid ? retailPriceArr : [];
}
